import React from "react";
import api from "../../api/Api";

// react component used to create a calendar with events on it
import BigCalendar from "react-big-calendar";
// dependency plugin for react-big-calendar
import moment from "moment";
import Loader from '../../components/Loader'
// react component used to create alerts

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Heading from "components/Heading/Heading.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import {dashboardRouter} from "../../util/globalHelper"
import buttonStyle from "../../assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";

import {events} from "variables/general.jsx";

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class AppointmentCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            events: events,
            alert: null,
            data: null,
            redirect: false
        };
        this.hideAlert = this.hideAlert.bind(this);
        this.addNewEventAlert = this.addNewEventAlert.bind(this);
        this.selectedEvent = this.selectedEvent.bind(this);
    }

    selectedEvent(event) {
        this.props.history.push(dashboardRouter(`/appointment/view/${event.id}`))

    }

    CallReadApi = () => {
        api.getAppointment({})
            .then(json => {
                this.setState({data: json.data.data}, () => {
                    this.setState({
                        events: this.state.data.map(item => {
                            return item.status === "Completed" ?
                                {
                                    allDay: false,
                                    color: "green",
                                    start: new Date(new Date(item.date).getFullYear(), new Date(item.date).getMonth(), new Date(item.date).getDate(), parseInt(item.local_start_time.split(":")[0]), parseInt(item.local_start_time.split(":")[1])),
                                    end: new Date(new Date(item.date).getFullYear(), new Date(item.date).getMonth(), new Date(item.date).getDate(), (parseInt(item.local_start_time.split(":")[1]) === 30 ? parseInt(item.local_start_time.split(":")[0]) + 1 : parseInt(item.local_start_time.split(":")[0])), parseInt(item.local_start_time.split(":")[1]) === 30 ? 0 : 30),
                                    title: item.patient_id.user_id.name,
                                    id: item._id
                                } : {
                                    allDay: false,
                                    color: "orange",
                                    start: new Date(new Date(item.date).getFullYear(), new Date(item.date).getMonth(), new Date(item.date).getDate(), parseInt(item.local_start_time.split(":")[0]), parseInt(item.local_start_time.split(":")[1])),
                                    end: new Date(new Date(item.date).getFullYear(), new Date(item.date).getMonth(), new Date(item.date).getDate(), (parseInt(item.local_start_time.split(":")[1]) === 30 ? parseInt(item.local_start_time.split(":")[0]) + 1 : parseInt(item.local_start_time.split(":")[0])), parseInt(item.local_start_time.split(":")[1]) === 30 ? 0 : 30),
                                    title: item.patient_id.user_id.name,
                                    id: item._id
                                }
                        })
                    })
                })
            });
    };

    componentDidMount() {
        this.CallReadApi();
    }

    componentWillUnmount() {
        this.setState({
            redirect: false
        })
    }

    addNewEventAlert(slotInfo) {
        this.props.history.push(dashboardRouter(`/appointment/book/schedule/${new Date(slotInfo.slots[0]).getTime()}`))
        //
        // this.setState({
        //     alert: (
        //         <SweetAlert
        //             input
        //             showCancel
        //             style={{display: "block", marginTop: "-100px"}}
        //             title="Input something"
        //             onConfirm={e => this.addNewEvent(e, slotInfo)}
        //             onCancel={() => this.hideAlert()}
        //             confirmBtnCssClass={
        //                 this.props.classes.button + " " + this.props.classes.success
        //             }
        //             cancelBtnCssClass={
        //                 this.props.classes.button + " " + this.props.classes.danger
        //             }
        //         />
        //     )
        // });
    }

    addNewEvent(e, slotInfo) {
        var newEvents = this.state.events;
        newEvents.push({
            title: e,
            start: slotInfo.start,
            end: slotInfo.end
        });
        this.setState({
            alert: null,
            events: newEvents
        });
    }

    hideAlert() {
        this.setState({
            alert: null
        });
    }

    eventColors(event, start, end, isSelected) {
        var backgroundColor = "event-";
        event.color
            ? (backgroundColor = backgroundColor + event.color)
            : (backgroundColor = backgroundColor + "default");
        return {
            className: backgroundColor
        };
    }

    render() {
        if (this.state.data)
            return (
                <div>
                    <Heading
                        textAlign="center"
                        title="Appointment Calendar"
                        category={
                            <span>

            </span>
                        }
                    />
                    {this.state.alert}
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={10}>
                            <Card>
                                <CardBody calendar>
                                    <BigCalendar
                                        selectable
                                        events={this.state.events}
                                        defaultView="month"
                                        scrollToTime={new Date(1970, 1, 1, 6)}
                                        defaultDate={new Date()}
                                        onSelectEvent={event => this.selectedEvent(event)}
                                        onSelectSlot={slotInfo => this.addNewEventAlert(slotInfo)}
                                        eventPropGetter={this.eventColors}
                                    />
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (
            <div>
                <Loader/>
            </div>)

    }
}

export default withStyles(buttonStyle)(AppointmentCalendar);



// WEBPACK FOOTER //
// ./src/views/Appointments/appointmentCalendar.jsx